import React from 'react';

export const createRequiredContext = <TValue,>(name?: string) => {
    const context = React.createContext<TValue | null>(null);

    const useContext = () => {
        const contextValue = React.useContext(context);

        if (contextValue === null) {
            throw new Error(`${name || 'Context'} - value is used outside the provider`);
        }

        return contextValue;
    };

    return [useContext, context.Provider] as const;
};
